var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "my" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "userInfo",
        },
        [
          _c("div", { staticClass: "infoLeft" }, [
            _c("div", { staticClass: "leftTop" }, [
              _c(
                "div",
                { staticClass: "leftTop-avatar" },
                [
                  _vm.userInfo.Icon
                    ? _c("el-avatar", {
                        attrs: { size: 60, src: _vm.userInfo.Icon },
                      })
                    : _c("el-avatar", {
                        attrs: { size: 60, icon: "el-icon-user-solid" },
                      }),
                  _c("span", { staticClass: "userName" }, [
                    _vm._v(_vm._s(_vm.userInfo.PMC_Name)),
                    _c("br"),
                    _c("span", { staticStyle: { "margin-left": "20px" } }, [
                      _vm._v(_vm._s(_vm.userInfo.Person)),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "but" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.$router.go(-1)
                        },
                      },
                    },
                    [_vm._v("后退前页")]
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "leftBottom" }, [
              _c(
                "ul",
                _vm._l(_vm.menuList, function (item) {
                  return _c(
                    "li",
                    {
                      key: item.title,
                      class: _vm.menuActive == item.title ? "active" : "",
                      on: {
                        click: function ($event) {
                          return _vm.menuClick(item)
                        },
                      },
                    },
                    [
                      _vm._v(" " + _vm._s(item.title) + " "),
                      item.title == "通知" && _vm.UnreadTotal > 0
                        ? _c("el-badge", {
                            staticClass: "item",
                            attrs: { value: _vm.UnreadTotal, max: 99 },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                0
              ),
            ]),
          ]),
          _c("div", { staticClass: "infoRight" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.menuActive == "用户信息",
                    expression: "menuActive == '用户信息'",
                  },
                ],
                staticClass: "rightCard",
              },
              [
                _c("div", { staticClass: "cardHeader" }, [
                  _vm._v(_vm._s(_vm.menuActive)),
                ]),
                _c(
                  "div",
                  { staticClass: "cardContent" },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "form",
                        attrs: {
                          model: _vm.userInfo,
                          "label-width": "120px",
                          "label-position": "left",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "formLable",
                            staticStyle: {
                              padding: "0 0 20px 0",
                              "box-shadow": "none",
                              "align-items": "center",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "el-form-item__label",
                                staticStyle: {
                                  width: "100px",
                                  "text-align": "left",
                                },
                              },
                              [_vm._v(" 头像 ")]
                            ),
                            _vm.userInfo.Icon
                              ? _c("el-avatar", {
                                  attrs: { size: 100, src: _vm.userInfo.Icon },
                                })
                              : _c("el-avatar", {
                                  attrs: {
                                    size: 100,
                                    icon: "el-icon-user-solid",
                                  },
                                }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "手机号/用户名" } },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: 11,
                                type: "text",
                                "show-word-limit": "",
                              },
                              model: {
                                value: _vm.userInfo.AccountName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.userInfo, "AccountName", $$v)
                                },
                                expression: "userInfo.AccountName",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "公司名称" } },
                          [
                            _c("el-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.userInfo.PMC_Name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.userInfo, "PMC_Name", $$v)
                                },
                                expression: "userInfo.PMC_Name",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "联系人" } },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.userInfo.Person,
                                callback: function ($$v) {
                                  _vm.$set(_vm.userInfo, "Person", $$v)
                                },
                                expression: "userInfo.Person",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: {
                              height: "121px",
                              position: "relative",
                            },
                            attrs: { label: "签名" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "100%",
                                  display: "inline-block",
                                  height: "120px",
                                  border: "1px solid #ccc",
                                  "box-sizing": "border-box",
                                },
                              },
                              [
                                _vm.userInfo.Sign
                                  ? _c("el-image", {
                                      staticStyle: {
                                        width: "100%",
                                        height: "100%",
                                      },
                                      attrs: {
                                        src: _vm.userInfo.Sign,
                                        fit: "contain",
                                      },
                                    })
                                  : _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          width: "100%",
                                          height: "100%",
                                          display: "flex",
                                          "justify-content": "center",
                                          "align-items": "center",
                                          color: "#c0c4cc",
                                          background: "#f5f7fa",
                                        },
                                      },
                                      [_vm._v(" 暂无签名 ")]
                                    ),
                              ],
                              1
                            ),
                            _c(
                              "el-button",
                              {
                                staticStyle: {
                                  width: "100px",
                                  position: "absolute",
                                  right: "-115px",
                                  top: "30px",
                                },
                                attrs: { type: "primary" },
                                on: { click: _vm.openSignDialog },
                              },
                              [_vm._v("设置签名")]
                            ),
                            _c(
                              "el-button",
                              {
                                staticStyle: {
                                  width: "100px",
                                  position: "absolute",
                                  right: "-115px",
                                  top: "80px",
                                },
                                attrs: { type: "primary" },
                                on: { click: _vm.resetData },
                              },
                              [_vm._v("刷新")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  size: "mini",
                                  type: "primary",
                                  loading: _vm.loading,
                                },
                                on: { click: _vm.onSubmitUserInfo },
                              },
                              [_vm._v("保存 ")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.menuActive == "修改密码",
                    expression: "menuActive == '修改密码'",
                  },
                ],
              },
              [
                _c("div", { staticClass: "rightCard" }),
                _c("div", { staticClass: "rightCard" }, [
                  _c("div", { staticClass: "cardHeader" }, [
                    _vm._v("修改密码"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "cardContent" },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "form",
                          attrs: {
                            model: _vm.form,
                            "label-width": "100px",
                            "label-position": "right",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "旧密码：" } },
                            [
                              _c("el-input", {
                                attrs: { "show-password": "" },
                                model: {
                                  value: _vm.form.oldPwd,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "oldPwd", $$v)
                                  },
                                  expression: "form.oldPwd",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "新密码：" } },
                            [
                              _c("el-input", {
                                attrs: { "show-password": "" },
                                model: {
                                  value: _vm.form.newPwd,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "newPwd", $$v)
                                  },
                                  expression: "form.newPwd",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "确认新密码：" } },
                            [
                              _c("el-input", {
                                attrs: { "show-password": "" },
                                model: {
                                  value: _vm.form.confirmPwd,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "confirmPwd", $$v)
                                  },
                                  expression: "form.confirmPwd",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { staticClass: "lastBtn" },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { width: "120px" },
                                  attrs: {
                                    loading: _vm.loading,
                                    size: "mini",
                                    type: "primary",
                                  },
                                  on: { click: _vm.onSubmit },
                                },
                                [_vm._v("保存 ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "设置签名",
            visible: _vm.signQrcodeDialogVisible,
            width: "300px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.signQrcodeDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                color: "red",
                "font-weight": "bold",
                "font-size": "16px",
                "text-align": "center",
              },
            },
            [_vm._v(" 请用手机扫描二维码设置签名 ")]
          ),
          _c(
            "div",
            { staticStyle: { width: "100%", "text-align": "center" } },
            [_c("vue-qr", { attrs: { size: 200, text: _vm.signQrcode } })],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.signQrcodeDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }